import { useMutation, useQuery } from '@apollo/client';
import { Anchor, Divider, Group, Loader, Table, Text } from '@mantine/core';
import { ProductFamily } from '__generated__/graphql';
import { GET_INVOICES, GET_SELF } from 'graphql/queries';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { css } from '@emotion/react';
import { toDate } from 'pages/Authed/LogbookPage/utils';

const ProductMap: Record<ProductFamily, string> = {
    CARDIAC_CT: 'Cardiac CT',
    BREAST_MRI: 'Breast MRI'
};

export function UserProfileSubscriptions() {
    const { data, loading, error } = useQuery(GET_SELF, {
        fetchPolicy: 'network-only'
    });
    const { data: invoicesData, loading: invoicesLoading } = useQuery(GET_INVOICES);

    const subs = data?.me?.productSubscriptions?.sort(
        (a, b) => toDate(a.startDate).getTime() - toDate(b.startDate).getTime()
    );
    const sortedInvoice = invoicesData?.invoices?.sort(
        (a, b) => toDate(a.createdAt).getTime() - toDate(b.createdAt).getTime()
    );

    const openLink = (url?: string | null) => {
        if (!url) {
            // todo: popup an alter
            return;
        }

        window.open(url, '_blank');
    };

    return (
        <div>
            <Text size="lg" mb="lg">
                Your subscriptions
                <Divider />
            </Text>
            <Table>
                <Table.Thead>
                    <Table.Tr fw="bold">
                        <Table.Td>Product</Table.Td>
                        <Table.Td>Start Date</Table.Td>
                        <Table.Td>End Date</Table.Td>
                    </Table.Tr>
                </Table.Thead>
                <Table.Tbody>
                    {subs?.map((s, idx) => (
                        <Table.Tr>
                            <Table.Td>{ProductMap[s.product]}</Table.Td>
                            <Table.Td>{new Date(s.startDate).toLocaleDateString()}</Table.Td>
                            <Table.Td>{new Date(s.endDate).toLocaleDateString()}</Table.Td>
                            <Table.Td>
                                <Anchor
                                    size="sm"
                                    onClick={() => openLink(sortedInvoice?.[idx]?.url)}
                                    c={invoicesLoading ? 'gray' : 'blue'}
                                >
                                    <Group justify="center" align="center" gap={4}>
                                        Invoice{' '}
                                        {invoicesLoading ? (
                                            <Loader size="xs" color="gray" />
                                        ) : (
                                            <OpenInNewIcon
                                                css={css`
                                                    height: 0.8em;
                                                    width: 0.8em;
                                                `}
                                            />
                                        )}
                                    </Group>
                                </Anchor>
                            </Table.Td>
                        </Table.Tr>
                    ))}
                    {/* This is an abomination */}
                    {/* {Object.keys(ProductMap)
                        .filter((p) => !subs?.map((s) => s.product as string).includes(p))
                        .map((p) => (
                            <Table.Tr>
                                <Table.Td>{ProductMap[p as ProductFamily]}</Table.Td>
                                <Table.Td>Not yet subscribed</Table.Td>
                            </Table.Tr>
                        ))} */}
                </Table.Tbody>
            </Table>
        </div>
    );
}
